import { useEffect } from "react";
import { blogPosts } from "@/data/blogPosts";

export const SITE_URL = "https://kevingreenspan.com";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

function truncate(text, max = 155) {
  if (text.length <= max) return text;
  return text.slice(0, max).replace(/\s+\S*$/, "").trim() + "…";
}

export const routeMeta = {
  "/": {
    title: "Dr. Kevin Greenspan, DC | Chiropractor Marion NC",
    description:
      "Dr. Kevin Greenspan, DC — Chiropractor in Marion & Black Mountain, NC. Applied Kinesiology, extremity adjustments and full spine care. Tue & Thu at Earth Heart, Marion; alternate Saturdays in Black Mountain. Call (828) 691-3551.",
    type: "website",
    sitemap: { changefreq: "weekly", priority: "1.0" },
  },
  "/book-online": {
    title: "Book Online | Dr. Kevin Greenspan, DC, Marion NC",
    description:
      "Schedule a chiropractic appointment with Dr. Kevin Greenspan in Marion, NC. Choose a service and time online — Tuesdays & Thursdays at Earth Heart on Highway 221 North. $50 flat visit fee.",
    type: "website",
    sitemap: { changefreq: "monthly", priority: "0.9" },
  },
  "/marion": {
    title: "Chiropractor in Marion, NC — Dr. Kevin Greenspan, inside Earth Heart on US 221",
    description:
      "Dr. Kevin Greenspan, DC, sees patients Tuesdays and Thursdays inside Earth Heart Health Foods, 4573 US 221 N, Marion. Full spine, extremity, AK, K-Laser. (828) 691-3551.",
    type: "website",
    sitemap: { changefreq: "monthly", priority: "0.9" },
  },
  "/black-mountain": {
    title: "Chiropractor in Black Mountain, NC — Saturday Hours | Dr. Kevin Greenspan, DC",
    description:
      "Dr. Kevin Greenspan sees patients on alternate Saturdays, 12:30–3:00 PM, at Mindful Wellness Space, 3174 US Hwy 70 W, Black Mountain, NC. Full spine, extremity adjusting, Applied Kinesiology and K-Laser. Phone bookings only: (828) 691-3551.",
    type: "website",
    sitemap: { changefreq: "monthly", priority: "0.8" },
  },
  "/blog": {
    title: "Wellness Articles | Dr. Kevin Greenspan, DC",
    description:
      "Practical tips for everyday wellness from forty years of chiropractic practice — back care, posture, lifting, sleep and gentle movement from Dr. Kevin Greenspan in Marion, NC.",
    type: "website",
    sitemap: { changefreq: "weekly", priority: "0.8" },
  },
  "/card": {
    title: "Digital Business Card | Dr. Kevin Greenspan, DC",
    description:
      "Save Dr. Kevin Greenspan's contact card. Chiropractor in Marion, NC — Applied Kinesiology, extremity adjustments and full spine care at Earth Heart, 4573 US 221 N. (828) 691-3551.",
    type: "profile",
    sitemap: { changefreq: "monthly", priority: "0.6" },
  },
  "/advisor": {
    title: "Kevin Greenspan | Greenspan Business Growth Systems",
    description:
      "Digital business card for Kevin Greenspan, Founder & Advisor at Greenspan Business Growth Systems — helping businesses and professionals build their digital presence.",
    type: "profile",
    sitemap: null,
  },
};

blogPosts.forEach((post) => {
  routeMeta[`/blog/${post.slug}`] = {
    title: `${post.title} | Dr. Greenspan, DC`,
    description: truncate(post.excerpt),
    type: "article",
    post,
    sitemap: { changefreq: "monthly", priority: "0.7" },
  };
});

export const prerenderRoutes = Object.keys(routeMeta);

export function canonicalFor(path) {
  return path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
}

export function usePageMeta(path) {
  useEffect(() => {
    const meta = routeMeta[path];
    if (!meta) return;
    document.title = meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", meta.description);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", canonicalFor(path));
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title: meta.title,
        page_location: window.location.href,
        page_path: path,
      });
    }
  }, [path]);
}
